const RETIRE_SMS_BANNER = 'ui_security_app_enable_retire_sms_banner';
const MAINTENANCE_BANNER = 'banner_info';
const MAINTENANCE_BANNER_UNSCHED = 'banner_unsched_maintenance';
const RU_LOCALE_DISABLED = 'ru_locale_disabled';
const LOGOUT_PAGE_ENABLED = 'ui_logout_page_enabled';
const EXPIRED_TOKEN_LOGOUT_ENABLED = 'ui_expired_token_logout_enabled';
const LOGIN_PAGE_ENABLED = 'ui_login_page_enabled';
const USERTHUMBNAILS_FIELD_ENABLED = 'ui_userthumbnails_field_enabled';
const SIDE_NAV_DISABLED = 'ui_side_nav_disabled';
const UI_USERPROFILE_V2_FIELDS = 'ui_userprofile_v2_fields';
const MFE_DEBUG_LOGS = 'ui_mfe_debug_logs';
const UI_WEB_PRODUCTS_ENABLED = 'ui_web_products_enabled';
const UI_CONTENTFUL_ENABLED = 'ui_contentful_enabled';
const MFE_CONTENTFUL_ENABLED = 'mfe_contentful_enabled';
const UI_EDUNEXT_ENABLED = 'ui_edunext_enabled';

// Apigee X feature flags

const MFE_APIGEEX_ENABLED = 'ui_mfe_apigeex_enabled';
const PROFILE_APIGEEX_ENABLED = 'ui_profile_apigeex_enabled';

export const FLAG_NAMES = {
  RETIRE_SMS_BANNER,
  MAINTENANCE_BANNER,
  MAINTENANCE_BANNER_UNSCHED,
  RU_LOCALE_DISABLED,
  LOGOUT_PAGE_ENABLED,
  EXPIRED_TOKEN_LOGOUT_ENABLED,
  LOGIN_PAGE_ENABLED,
  USERTHUMBNAILS_FIELD_ENABLED,
  SIDE_NAV_DISABLED,
  UI_USERPROFILE_V2_FIELDS,
  MFE_DEBUG_LOGS,
  UI_WEB_PRODUCTS_ENABLED,
  UI_CONTENTFUL_ENABLED,
  MFE_CONTENTFUL_ENABLED,
  UI_EDUNEXT_ENABLED,
  // Apigee X feature flags
  MFE_APIGEEX_ENABLED,
  PROFILE_APIGEEX_ENABLED,
};

// FALLBACK_FLAGS should match production LaunchDarkly values
// Last synced: 2026-02-05
// These values are used when LaunchDarkly fails to load
export const FALLBACK_FLAGS = {
  [RETIRE_SMS_BANNER]: {},
  [MAINTENANCE_BANNER]: {},
  [MAINTENANCE_BANNER_UNSCHED]: true,
  [RU_LOCALE_DISABLED]: true,
  [LOGOUT_PAGE_ENABLED]: false,
  [EXPIRED_TOKEN_LOGOUT_ENABLED]: false,
  [LOGIN_PAGE_ENABLED]: true,
  [USERTHUMBNAILS_FIELD_ENABLED]: true,
  [SIDE_NAV_DISABLED]: false,
  [UI_USERPROFILE_V2_FIELDS]: true,
  [MFE_DEBUG_LOGS]: false,
  [UI_WEB_PRODUCTS_ENABLED]: false,
  [UI_CONTENTFUL_ENABLED]: false,
  [MFE_CONTENTFUL_ENABLED]: false,
  [UI_EDUNEXT_ENABLED]: false,
  [MFE_APIGEEX_ENABLED]: true,
  [PROFILE_APIGEEX_ENABLED]: true,
};
